import Link from 'components/Link';
import {FC} from 'react';
import {jt, t} from 'ttag';

import {PdfFilenameElementOption} from '../../types';

type PdfFilenameComponentNameProps = {
    element: PdfFilenameElementOption;
};

const PdfFilenameComponentName: FC<PdfFilenameComponentNameProps> = ({
    element,
}) => {
    const getString = (element: string) => {
        const link = (
            <Link
                href="https://help.makeleaps.jp/ja/articles/8059992"
                isOpenInNewTab={true}
            >{t`Help Center`}</Link>
        );
        if (element === 'client_name') return t`Client - Name`;
        if (element === 'client_name_honorific')
            return t`Client - Name + Honorific title`;
        if (element === 'document_cost') return t`Document - Total`;
        if (element === 'document_date') return t`Document - Date`;
        if (element === 'document_number') return t`Document - Number`;
        if (element === 'document_type_en') return t`Document - Type (English)`;
        if (element === 'document_type_ja')
            return t`Document - Type (Japanese)`;
        if (element === 'document_type_legacy')
            return jt`Document - Type (Legacy, see ${link})`;
        if (element === 'document_type_match')
            return t`Document - Type (Match Template Language)`;
        if (element === 'partner_name_en')
            return t`Your Company - Name (English)`;
        if (element === 'partner_name_ja')
            return t`Your Company - Name (Japanese)`;
        if (element === 'partner_name_match')
            return t`Your Company - Name (Match Template Language)`;
        throw new Error(`Invalid element '${element}'`);
    };
    return getString(element);
};

export default PdfFilenameComponentName;
